module.exports = __webpack_public_path__ + "static/media/actidoo-a.f975a3a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/actidoo-a.png
// module id = 225
// module chunks = 1